module.exports = __webpack_public_path__ + "static/img/Mumbai.72b5e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/city/Mumbai.png
// module id = 4sxp
// module chunks = 12